import { useEffect, useRef } from 'react';
import useNavParams from './useNavParams';

const useSubNavigation = <T>(
  defaultPage: T & (string | number),
  key = 'page'
) => {
  const isInitialMount = useRef(<boolean>true);
  const { params, setParams } = useNavParams();
  const activePage = (params?.[key] as T & (string | number)) || defaultPage;

  const setPage = (
    page: T & (string | number),
    params?: Record<string, string>
  ) => {
    setParams({ [key]: page.toString(), ...params });
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    setPage(activePage ? activePage : defaultPage);
  }, [params]);

  return {
    activePage,
    setPage,
    params
  };
};

export default useSubNavigation;
